<template>
  <!--====== Section: 가격 플랜 + 외주 vs AI Studio 비교 ======-->
  <section class="appie-blog-3-area appie-blog-8-area pt-90 pb-100">
    <div class="container">
      <!-- 외주 vs AI Studio 비교표 -->
      <div class="row">
        <div class="col-lg-12">
          <div class="appie-section-title text-center">
            <h3 class="appie-title">외주 개발도 진화합니다</h3>
            <p>AI Studio는 외주를 없애는 게 아니라, 외주를 진화시킵니다.</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mt-30">
        <div class="col-lg-10">
          <div class="table-responsive">
            <table class="table table-bordered text-center compare-table">
              <thead>
                <tr>
                  <th style="width:16%">구분</th>
                  <th style="width:28%">일반 외주</th>
                  <th style="width:28%">노코드 서비스</th>
                  <th style="width:28%; background-color: #0a44b9; color: #fff;">스윙투앱 AI Studio</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>속도</strong></td>
                  <td>인력 의존</td>
                  <td>빠름</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">AI 가속</td>
                </tr>
                <tr>
                  <td><strong>수정</strong></td>
                  <td>비용 증가</td>
                  <td>직접 수정 가능</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">유연한 반영</td>
                </tr>
                <tr>
                  <td><strong>결과 공유</strong></td>
                  <td>후반</td>
                  <td>즉시 확인</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">초기부터 공유</td>
                </tr>
                <tr>
                  <td><strong>자유도</strong></td>
                  <td>높음</td>
                  <td>템플릿 제한</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">높음</td>
                </tr>
                <tr>
                  <td><strong>리스크</strong></td>
                  <td>큼</td>
                  <td>낮음</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">낮음</td>
                </tr>
                <tr>
                  <td><strong>완성도</strong></td>
                  <td>편차 큼</td>
                  <td>기본 수준</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">표준화된 품질</td>
                </tr>
                <tr>
                  <td><strong>유지보수</strong></td>
                  <td>별도 계약 필요</td>
                  <td>플랫폼 의존</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">지속 운영 지원</td>
                </tr>
                <tr>
                  <td><strong>관리자 페이지</strong></td>
                  <td>추가 개발 비용</td>
                  <td>기본 제공 (제한적)</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">기본 포함</td>
                </tr>
                <tr>
                  <td><strong>가격</strong></td>
                  <td>높음</td>
                  <td>월 구독형</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">합리적 프로젝트비</td>
                </tr>
                <tr>
                  <td><strong>특징</strong></td>
                  <td>완전 맞춤 가능<br>but 시간·비용 부담</td>
                  <td>빠르지만<br>기능·디자인 제약</td>
                  <td style="background-color: #f0f4ff; color: #0a44b9; font-weight: 600;">맞춤 개발 +<br>AI 속도 + 운영 지원</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 가격 플랜 -->
      <div class="row mt-60">
        <div class="col-lg-12">
          <div class="appie-section-title text-center">
            <h3 class="appie-title">AI Studio 제작 플랜</h3>
            <p>같은 인력, AI를 쓰느냐 안 쓰느냐의 차이입니다.</p>
          </div>
        </div>
      </div>
      <div class="row justify-content-center mt-30">
        <div class="col-lg-4 col-md-6">
          <div class="pricing-card wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
            <div class="pricing-header">
              <h4>MVP 제작</h4>
              <p class="price">300만 ~ 700만 원</p>
            </div>
            <ul class="pricing-features">
              <li><i class="fal fa-check"></i> 웹 또는 앱 1종</li>
              <li><i class="fal fa-check"></i> AI 기반 설계 + 개발</li>
              <li><i class="fal fa-check"></i> 관리자 페이지</li>
              <li><i class="fal fa-check"></i> 초기 수정 집중 반영</li>
              <li><i class="fal fa-check"></i> 빠른 MVP 검증</li>
              <li><i class="fal fa-check"></i> 스토어 출시 지원</li>
            </ul>
            <a href="#" @click.prevent="$root.$emit('open-contact-popup', 'mvp')" class="main-btn" style="display:block; text-align:center;">상담 신청</a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="pricing-card active wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="400ms">
            <div class="pricing-header">
              <h4>서비스 런칭형</h4>
              <p class="price">800만 ~ 1,500만 원</p>
            </div>
            <ul class="pricing-features">
              <li><i class="fal fa-check"></i> 웹 + 앱 동시 제작</li>
              <li><i class="fal fa-check"></i> 전문가 기반 설계 및 기획</li>
              <li><i class="fal fa-check"></i> 관리자 페이지</li>
              <li><i class="fal fa-check"></i> 운영 고려 설계</li>
              <li><i class="fal fa-check"></i> 초기 데이터 삽입</li>
              <li><i class="fal fa-check"></i> 스토어 출시 지원</li>
            </ul>
            <a href="#" @click.prevent="$root.$emit('open-contact-popup', 'launch')" class="main-btn" style="display:block; text-align:center;">상담 신청</a>
          </div>
        </div>
        <div class="col-lg-4 col-md-6">
          <div class="pricing-card wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="600ms">
            <div class="pricing-header">
              <h4>고도화 / 운영형</h4>
              <p class="price">별도 협의</p>
            </div>
            <ul class="pricing-features">
              <li><i class="fal fa-check"></i> 기능 확장</li>
              <li><i class="fal fa-check"></i> 외부 API 연동</li>
              <li><i class="fal fa-check"></i> 관리자 페이지</li>
              <li><i class="fal fa-check"></i> 지속 개선</li>
              <li><i class="fal fa-check"></i> 유지보수</li>
              <li><i class="fal fa-check"></i> 스토어 출시 지원</li>
            </ul>
            <a href="#" @click.prevent="$root.$emit('open-contact-popup', 'advanced')" class="main-btn" style="display:block; text-align:center;">상담 신청</a>
          </div>
        </div>
      </div>
    </div>
    <div class="appie-blog-8-shape-1">
      <img src="@/assets/images/shape/5.png" alt="">
    </div>
    <div class="appie-blog-8-shape-2">
      <img src="@/assets/images/shape/shape-12.png" alt="">
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style scoped>
.compare-table {
  font-size: 16px;
}
.compare-table th {
  background-color: #2a2a2a;
  color: #fff;
  font-weight: 600;
  padding: 15px;
}
.compare-table td {
  padding: 12px 15px;
  vertical-align: middle;
}
.mt-60 {
  margin-top: 60px;
}
.pricing-card {
  background: #fff;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
  transition: all 0.3s ease;
}
.pricing-card:hover,
.pricing-card.active {
  box-shadow: 0 5px 30px rgba(10, 68, 185, 0.15);
  transform: translateY(-5px);
}
.pricing-card.active {
  border: 2px solid #0a44b9;
}
.pricing-header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.pricing-header h4 {
  font-size: 22px;
  font-weight: 700;
  margin-bottom: 10px;
}
.pricing-header .price {
  font-size: 18px;
  color: #0a44b9;
  font-weight: 600;
}
.pricing-features {
  list-style: none;
  padding: 0;
  margin-bottom: 25px;
}
.pricing-features li {
  padding: 8px 0;
  font-size: 15px;
  color: #505056;
}
.pricing-features li i {
  color: #0a44b9;
  margin-right: 8px;
}
</style>
